import axios from 'axios';
import { HttpMethods } from '@/api/base';
import { BASE_PATH } from './constants';
import type { GovernmentPricingModule, GovernmentPricingPayload } from './types';

export type GetGovernmentPricingBreakdownService = {
  intakeId: string | number;
};

export type GetGovernmentPricingBreakdownResponse = {
  data: GovernmentPricingPayload;
};

export type PostGovernmentPricingBreakdownService = {
  intakeId: string | number;
  pricingBreakdown: GovernmentPricingModule[];
};

export type PostGovernmentPricingBreakdownResponse = {
  data: GovernmentPricingPayload;
};

export async function getGovernmentPricingBreakdown({
  intakeId,
}: GetGovernmentPricingBreakdownService): Promise<GetGovernmentPricingBreakdownResponse> {
  const res = await axios.request<GetGovernmentPricingBreakdownResponse>({
    method: HttpMethods.GET,
    url: `${BASE_PATH}/${intakeId}/pricing-breakdown`,
  });
  return res.data;
}

export async function postGovernmentPricingBreakdown({
  intakeId,
  pricingBreakdown,
}: PostGovernmentPricingBreakdownService): Promise<PostGovernmentPricingBreakdownResponse> {
  const res = await axios.request<PostGovernmentPricingBreakdownResponse>({
    method: HttpMethods.POST,
    url: `${BASE_PATH}/${intakeId}/pricing-breakdown`,
    data: { pricingBreakdown },
  });
  return res.data;
}
